// @flow

import React from 'react';

import { SessionStore, RouteStore } from 'stores';
import { SessionAction } from 'actions';
import { Events } from 'constants';
import RoutingEnum from 'constants/RoutingEnum';

import LoginForm from './components/LoginForm';
import AbstractComponent from 'components/AbstractComponent';

export default class LoginPage extends AbstractComponent {

  componentDidMount() {
    if (SessionStore.isLoggedIn()) {
      RouteStore.redirectTo(RoutingEnum.DASHBOARD);
    }

    SessionStore.addListener(Events.ON_LOGIN_ERROR, this.onError);
  }

  componentWillUnmount() {
    SessionStore.removeListener(Events.ON_LOGIN_ERROR, this.onError);
  }

  // -- events - API
  onError = () => {
    this.hideLoading();
    const apiError = SessionStore.getApiError();

    this.attachApiError(apiError);
  };

  // -- events form
  onLogin = (username: string, password: string) => {
    this.showLoading();
    SessionAction.login(username, password);
  };

  // -- renderers

  render() {
    return (
      <div className="login_page top-buffer-50">

        {this.renderLoading()}

        <div className="col-xs-12 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3">
          {this.renderApiErrorBlock()}
          <LoginForm
            onLogin={this.onLogin}
          />
        </div>

      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./scripts/pages/login/LoginPage.js